const slick = require('slick-carousel');
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

var Timeline = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-Timeline',
  };

  $.extend(true, this.options, options);
};

/**
 * Init'ing our events
 * @return {[type]} [description]
 */
Timeline.prototype.init = function() {
  var self = this;

  self.$timeline = self.options.$el;
  self.$navList = self.$timeline.find(`.${self.data.baseClass}__nav__list`);
  self.$contentList = self.$timeline.find(
    `.${self.data.baseClass}__content__list`,
  );
  self.$arrowLeft = self.$timeline.find(`.${self.data.baseClass}__arrow-left`);
  self.$arrowRight = self.$timeline.find(
    `.${self.data.baseClass}__arrow-right`,
  );

  self.$contentList.slick({
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    infinite: false,
    arrows: false,
    dots: false,
    asNavFor: self.$navList,
  });

  self.$navList.slick({
    speed: 300,
    slidesToShow: 11,
    adaptiveHeight: true,
    infinite: false,
    focusOnSelect: true,
    asNavFor: self.$contentList,
    centerMode: true,
    arrows: true,
    dots: false,
    prevArrow: self.$arrowLeft,
    nextArrow: self.$arrowRight,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 9,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
};

export default Timeline;
